import React, { Component } from "react";
import { MDBDataTable } from "mdbreact";
import { Button } from "@material-ui/core";
import ReactInputHandler from "react-input-handler";
import axios from "axios";
import apiURL from "../../config/api.json";
import { toast } from "react-toastify";
import LoadingOverlay from "react-loading-overlay";
import { setInStorage, removeFromStorage } from "../../utils/storage.js";
//import ReactExport from "react-export-excel";
import { getImage } from "./Images";
import { CloudDownload, PictureAsPdfRounded, Print, Edit } from "@material-ui/icons";

//const ExcelFile = ReactExport.ExcelFile;
//const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
//const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class ReferringPhysicianList extends Component {
  constructor(props) {
    super(props);
    this.handleChange = ReactInputHandler.bind(this);
  }
  state = {
    data: {
      columns: [
        {
          label: "Patient ID",
          field: "pid",
          sort: "asc",
          width: "auto",
          background: "green"
        },
        {
          label: "Name",
          field: "name",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Age",
          field: "age",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Examined Organ",
          field: "examined_organ",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Assigned To",
          field: "assigned_to",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Uploaded Date",
          field: "uploaded_date",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Reporting Date",
          field: "reporting_date",
          sort: "asc",
          width: "auto",
        },
        {
          label: "No. of Images",
          field: "images_no",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Status",
          field: "status",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Report",
          field: "report",
          sort: "asc",
          width: "auto",
        },
        {
          label: "Edit Case",
          field: "edit_case",
          sort: "asc",
          width: "auto",
        }
      ],
      rows: []
    },
    wordDoc: [],
    isLoading: false,
    isPdf: false,
    isActive: false,
    html: "",
    open: false,
    base64: ""
  };

  changeIsActive = isActive => {
    this.setState({ isActive });
  };

  //Error notification
  notifyError = error => {
    toast.error("" + error.toString());
  };

  //Fetch view image using POST request
  fetchImageData = (case_id, data) => {
    removeFromStorage("View")
    axios
      .post(
        apiURL.postMethodURL,
        {
          task: "downloadImageFiles",
          case_id: case_id.toString(),
          numImage: "1"
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
      .then(res => {
        this.setState({ img: res.data.records[0][0].img0 }, () => {
          this.changeIsActive(false);
          this.fetchDocData1(case_id, data);
        });
      })
      .catch(err => {
        this.notifyError(err.toString());
      });
  };

  //Fetch doc data using POST request
  fetchDocData1 = (report_id, data) => {
    axios
      .post(
        apiURL.postMethodURL,
        {
          task: "getWordFilePrintInfo",
          report_id: report_id.toString()
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
      .then(res => {
        getImage(res.data[0].assigned_to).then((response) => {
          this.setState({base64: `data:image/png;base64,${response}`},
          () => {
            setInStorage("name",  res.data[0].name)
            if (typeof res.data[0].report === "string") {
              axios
                .post(
                  apiURL.docApi,
                  {
                    pid: res.data[0].pid,
                    report: res.data[0].report,
                    name: res.data[0].name,
                    age: res.data[0].age,
                    gender: res.data[0].gender,
                    upload_date: res.data[0].upload_date,
                    report_date: res.data[0].report_date,
                    body_parts: res.data[0].body_parts,
                    referrer: res.data[0].referrer,
                    isPdf: false,
                    image: this.state.base64
                  },
                  {
                    headers: { "Content-Type": "application/json" }
                  }
                )
                .then(res => {
                  this.setState({ isActive: false }, () => {
                    this.intializationOfData();
                    setInStorage("View", {
                      image: this.state.img,
                      case_id: report_id,
                      data,
                      html: res.data.html
                    });
                    window.open("/#/EditCase")
                  });
                })
                .catch(err => {
                  this.setState({ isActive: false });
                  this.notifyError(err.toString());
                });
            } else {
              this.setState({ isActive: false });
              window.open("/#/EditCase")
            }
          }
        )
      }
    )
    .catch(
        (error) => {
            console.log(error);
        }
    )
      })
      .catch(err => {
        this.setState({ isFetchedList: true, isActive: false });
        this.notifyError(err.toString());
      });
  };

  //Fetch doc data using POST request
  fetchDocData = report_id => {
    axios
      .post(
        apiURL.postMethodURL,
        {
          task: "getWordFilePrintInfo",
          report_id: report_id.toString()
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
      .then(res => {
        getImage(res.data[0].assigned_to).then(
          (response) => {
              this.setState({base64: `data:image/png;base64,${response}`},
              () => {
                setInStorage("name",  res.data[0].name)
                const Name=res.data[0].name

                if (typeof res.data[0].report === "string") {
                  axios
                    .post(
                      apiURL.docApi,
                      {
                        pid: res.data[0].pid,
                        report: res.data[0].report,
                        name: res.data[0].name,
                        age: res.data[0].age,
                        gender: res.data[0].gender,
                        upload_date: res.data[0].upload_date,
                        report_date: res.data[0].report_date,
                        body_parts: res.data[0].body_parts,
                        referrer: res.data[0].referrer,
                        isPdf: this.state.isPdf,
                        image: this.state.base64
                      },
                      {
                        headers: { "Content-Type": "application/json" },
                        responseType: this.state.isPdf && "blob"
                      }
                    )
                    .then(res => {
                      if (this.state.isPdf) {
                        const file = new Blob([res.data], {
                          type: "application/pdf"
                        });

                        const fileURL = URL.createObjectURL(file);
                        let a = document.createElement("a");
                        a.href = fileURL;
                        a.download = `${Name}.pdf`;
                        a.click();
                      } else {
                        this.setState({ html: res.data.html, open: true }, () => {
                          this.intializationOfData();
                        });
                        setInStorage("html", res.data.html);
                        window.open("/#/Html");
                      }
                      this.setState({ isActive: false });
                    })
                    .catch(err => {
                      this.setState({ isActive: false });
                    });
                } else {
                  this.setState({ isActive: false });
                  this.notifyError("Reports not found");
                }
              }
            )
          }
        )
        .catch(
            (error) => {
                console.log(error);
            }
        )
      })
      .catch(err => {
        this.setState({ isFetchedList: true, isActive: false });
        this.notifyError(err.toString());
      });
  };

  //Set Priority POST request
  setPriority = () => {
    this.setState({ isLoading: true }, () => {
      axios
        .post(
          apiURL.postMethodURL,
          {
            task: "setCasePriority",
            pid: this.state.pid
          },
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(res => {
          if (this.props.fromDate === "" && this.props.toDate === "") {
            this.props.fetchListView();
          } else {
            this.props.fetchListViewBetweenDates();
          }
        })
        .catch(err => {
          this.setState({ isLoading: false });
          this.notifyError(err.toString());
        });
    });
  };

  //onClick Set Priority
  setPriorityHandler = () => {
    this.setPriority();
  };

  //onClick set referrer handler
  setReferrer = (index, e) => {
    console.log(this.state.referrer[index]);
  };

  //Word doc click handler
  wordDocHandler = (id, e) => {
    this.setState({ isPdf: false, isActive: true }, () => {
      this.fetchDocData(id);
    });
  };

  //Pdf click handler
  pdfHandler = (id, e) => {
    this.setState({ isPdf: true, isActive: true }, () => {
      this.fetchDocData(id);
    });
  };

  handleClose = () => {
    this.setState({ open: false }, () => {
      this.intializationOfData();
    });
  };

  //Initialization of data
  intializationOfData = () => {
    let isButtonLoading = [];
    let newDataRows = [];

    this.props.listViewArr.forEach((item, i) => {
      isButtonLoading.push(false);
      const upload_date = typeof item.upload_date === "string" &&
        item.upload_date.substring(6, 8) +
        "/" +
        item.upload_date.substring(4, 6) +
        "/" +
        item.upload_date.substring(0, 4) +
        ", " +
        item.upload_date.substring(8, 10) +
        ":" +
        item.upload_date.substring(10, 12) +
        ":" +
        item.upload_date.substring(12, 14)
      const report_date = typeof item.report_date === "string" &&
        item.report_date.substring(6, 8) +
        "/" +
        item.report_date.substring(4, 6) +
        "/" +
        item.report_date.substring(0, 4) +
        ", " +
        item.report_date.substring(8, 10) +
        ":" +
        item.report_date.substring(10, 12) +
        ":" +
        item.report_date.substring(12, 14)
      newDataRows.push({
        report_id: item.report_id,
        pid: item.pid,
        name: item.name,
        age: item.age,
        examined_organ: (
          <span className={item.priority === 1 ? "colorChange" : ""}>
            {item.body_parts}
          </span>
        ),
        assigned_to: item.assigned_to,
        uploaded_date: typeof item.upload_date === "string" &&
              item.upload_date.substring(6, 8) +
                "/" +
                item.upload_date.substring(4, 6) +
                "/" +
                item.upload_date.substring(0, 4) +
                ", " +
                item.upload_date.substring(8, 10) +
                ":" +
                item.upload_date.substring(10, 12) +
                ":" +
                item.upload_date.substring(12, 14),
        reporting_date: typeof item.report_date === "string" &&
              item.report_date.substring(6, 8) +
                "/" +
                item.report_date.substring(4, 6) +
                "/" +
                item.report_date.substring(0, 4) +
                ", " +
                item.report_date.substring(8, 10) +
                ":" +
                item.report_date.substring(10, 12) +
                ":" +
                item.report_date.substring(12, 14),
        status: (
          <span
            style={{
              color:
                item.status === 0
                  ? "red"
                  : item.status === 2
                  ? "green"
                  : "blue",
              fontWeight: "bold"
            }}
            className={item.priority === 1 ? "colorChange" : ""}
          >
            {item.status === 0
              ? "Pending"
              : item.status === 2
              ? "Completed"
              : "In-View"}
          </span>
        ),
        images_no: item.image_count,
        report: (
          <React.Fragment>
            <Button
              style={{
                textTransform: "none",
                fontWeight: "bold",
                color: "#3b5998"
              }}
              variant="text"
              size="small"
              onClick={e => {
                this.wordDocHandler(item.report_id, e);
              }}
            >
              <Print fontSize="small"/> <span style={{marginLeft: "5px"}}> Word </span>
            </Button>
            <br />

            <Button
              id={i}
              style={{
                textTransform: "none",
                fontWeight: "bold",
                marginTop: "5px"
              }}
              size="small"
              variant="text"
              color="secondary"
              onClick={e => this.pdfHandler(item.report_id, e)}
            >
              <PictureAsPdfRounded fontSize="small"/> <span style={{marginLeft: "5px"}}>Pdf</span>
            </Button>
          </React.Fragment>
        ),
        edit_case:(      
            <Button
              variant="outlined"
              style={{ textTransform: "none", marginTop: "10px", fontWeight: "bold", color: "gray" }}
              size="small"
              onClick={()=>{
               
                this.setState({ isActive: true }, () => {
                  setInStorage("edit_case",[item.priority, item.report_id, item.assigned_to, item.body_parts, item.name])
                  this.fetchImageData(
                    item.report_id,
                    item.report_id +
                      "--" +
                      item.pid +
                      "--" +
                      item.name +
                      "--" +
                      item.age +
                      "--" +
                      item.gender +
                      "--" +
                      upload_date +
                      "--" +
                      report_date
                  );
                  
                })
               
            }}
            >
              <Edit fontSize="small" style={{fontSize: "16px"}}/> <span style={{marginLeft: "5px"}}>Edit</span>
            </Button>
        )
      });
    });

    this.setState({
      data: { columns: this.state.data.columns, rows: newDataRows }
    });
  };

  //This function will run first
  componentDidMount() {
    this.intializationOfData();
  }

  //Page rendering
  render() {
    const { data } = this.state

    return (
      <div>
        <LoadingOverlay
          active={this.state.isActive}
          spinner
          text="Loading, Please Wait..."
        >
	{/*
          <ExcelFile element={
            <Button variant="outlined" color="primary" size="small" style={{textTransform:"none", zIndex: 1, color: "white", backgroundColor: "green", position: "absolute", marginLeft: "-70px", marginTop: "5px"}}>
              <CloudDownload/> 
              <span style={{marginLeft: "5px"}}>Export To Excel</span>
            </Button>
          }>
            <ExcelSheet data={this.props.listViewArr} name="List">
                <ExcelColumn label="Diagnostic Center Name" value="institution"/>
                <ExcelColumn label="Patient ID" value="pid"/>
                <ExcelColumn label="Name" value="name"/>
                <ExcelColumn label="Age" value="age"/>
                <ExcelColumn label="Organ" value="body_parts"/>
                <ExcelColumn label="Upload Date" value={(col) => typeof col.upload_date === "boolean"
                                                            ? ""
                                                            : col.upload_date}
                />
                <ExcelColumn label="Report Date" value={(col) => typeof col.report_date === "boolean"
                                                            ? ""
                                                            : col.report_date}
                />
                <ExcelColumn label="Status" value={(col) => col.status === 0
                                                            ? "Pending"
                                                            : col.status === 2
                                                            ? "Completed"
                                                            : "In-View"}
                />
                <ExcelColumn label="Doctors Assigned" value="assigned_to"/>
            </ExcelSheet>
          </ExcelFile> */}
          <MDBDataTable
            striped
            responsive
            bordered
            entries={100}
            data={data}
            pagesAmount={5}
            noBottomColumns
            hover
            style={{ background: "white", color: "black" }}
          />
        </LoadingOverlay>
      </div>
    );
  }
}

export default ReferringPhysicianList;
